import React from 'react';
import { Container } from './styles';
import { menuListItems } from '../../assets/menu/menuList';
import { Menu } from '../../components/Menu';
import { SellersTable } from './SellersTable';

export const Sellers: React.FC = () => {

  return (
    <Menu links={menuListItems}>
      <Container>
        <SellersTable/>
      </Container>
    </Menu>
  )
}